import { render, staticRenderFns } from "./serviceValues.vue?vue&type=template&id=2fac6260&scoped=true&"
import script from "./serviceValues.vue?vue&type=script&lang=js&"
export * from "./serviceValues.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=2fac6260&scoped=true&lang=css&"
import style1 from "./serviceValues.vue?vue&type=style&index=1&id=2fac6260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac6260",
  null
  
)

export default component.exports